// import constant
import {
    LOADHISTORY
} from '../constant';

const initialState = {
    status: false
};

const loadHistory = (state = initialState, action) => {
    switch (action.type) {
        case LOADHISTORY:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}

export default loadHistory;